'use client';

import Clarity from '@microsoft/clarity';
import { type FC, useEffect } from 'react';

export const ClarityScript: FC = () => {
    useEffect(() => {
        if ('clarity' in window) {
            return;
        }

        if ('deviceMemory' in navigator) {
            const ram = navigator.deviceMemory as number;

            if (ram < 8) {
                return;
            }
        }

        if ('connection' in navigator) {
            const connection = navigator.connection as Record<string, unknown>;
            const internet = connection.effectiveType;

            if (internet === 'slow-2g' || internet === '2g' || internet === '3g') {
                return;
            }
        }

        Clarity.init('skd45b453l');
    }, []);

    return null;
};
